import type { TFunction } from 'i18next';

import type { TChannel } from '@feathr/blackbox';

/**
 * Returns the modal title based on the creative channel type.
 * @param channel - The channel type ('display' or 'meta')
 * @param t - Translation function
 * @returns The formatted modal title
 */
export function getModalTitle(channel: TChannel, t: TFunction): string {
  if (channel === 'display') {
    return t('Duplicate Existing Display Ad Creative');
  }
  return t('Duplicate Existing Meta Creative');
}

/**
 * Returns the modal subtitle text.
 * @param t - Translation function
 * @returns The modal subtitle
 */
export function getModalSubtitle(t: TFunction): string {
  return t('Select one or more creatives from your library to duplicate.');
}
